export enum PermissionsColumnNames {
  account = 'Account',
  type = 'Type',
  permissions = 'Permissions',
}

export enum NotificationsColumnNames {
  title = 'Title',
  event = 'Event',
  notification = 'Notification',
  status = 'Status',
}
